import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SubNavbar from '../../layout/SubNavbar';
import { setLoader } from '../../Store/slices/MasterSlice';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../utils/common.service';
import * as API from '../../utils/api.service';
import { useLocation } from 'react-router-dom';


export default function ContectUsReplay() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

 
    const contect = location.state?.contectUs; 
   


    const { register, handleSubmit, formState: { errors }, reset} = useForm();
    const onSubmit = async (submitData) => {
        try {
            dispatch(setLoader(true));
            var requestBody = {
                id:contect?.id,
                email:contect?.email,
                name:contect?.firstName,
                subject: submitData?.subject,
                description: submitData?.message,
            };
            const { code, message } = await API.contectUsReplay(requestBody);
            if (code === '1') {
                TOAST_SUCCESS(message);
                navigate(`/manage_contact`);
                reset();
            }
            dispatch(setLoader(false));
        } catch (err) {
            TOAST_ERROR(err.message);
            dispatch(setLoader(false));
        }
    };

    return (
        <>
            <div className="content">
                <div className="container-fluid">
                    <SubNavbar title={`Give Replay`} header={`contect us replay`} subHeader={`contect us replay`} />
                    <div className="card rounded-3">
                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row mt-3">

                                    {/* Subject Input */}
                                    <div className="mb-3 col-md-12">
                                        <label className="form-label">Subject</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="subject" 
                                            id="subject" 
                                            autoComplete='nope' 
                                            {...register('subject', { required: "Please enter subject" })} 
                                        />
                                        <label className="errorc">{errors.subject?.message}</label>
                                    </div>

                                    {/* Message Textarea */}
                                    <div className="mb-3 col-md-12">
                                        <label className="form-label">Message</label>
                                        <textarea 
                                            id="message" 
                                            name="message" 
                                            className="form-control" 
                                            {...register('message', { required: "Please enter message" })} 
                                            style={{ height: "150px" }} 
                                        ></textarea>
                                        <label className="errorc">{errors.message?.message}</label>
                                    </div>
                                </div>

                                <div className="mb-0 text-center">
                                    <button className="btn btn-soft-primary w-25 buttonColor" type="submit">
                                        <i className="ri-save-fill"></i> <span className="fw-bold">Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
